import { ORM } from "./CouchORM";

export default class SVG extends ORM {
    static collectionType = "SVG";
}